import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { dateService } from '@netwealth/nw-utils';
import { IconButtonComponent } from '../../button/button.component';
import { IconComponent } from '../../icon/icon.component';
import { LinkComponent } from '../../link/link.component';
import { FooterBlock, FooterLink, FooterSocialLink } from './models/footer.types';

@Component({
    selector: 'nw-footer',
    imports: [IconComponent, IconButtonComponent, LinkComponent],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
    @Input() warning: string = 'When investing your capital is at risk.';
    @Input() copy: string =
        `Copyright © ${dateService().getFullYear()} Netwealth Investments Ltd.\n All rights reserved.`;
    @Input() blocks!: FooterBlock[];
    @Input() support?: FooterLink[];
    @Input() socials: FooterSocialLink[] = [
        {
            icon: 'facebook',
            url: 'https://www.facebook.com/NetwealthUK/'
        },
        {
            icon: 'linkedin',
            url: 'https://uk.linkedin.com/company/netwealth'
        },
        {
            icon: 'x-twitter',
            url: 'https://twitter.com/netwealth'
        },
        {
            icon: 'youtube',
            url: 'https://www.youtube.com/@netwealth2936'
        },
        {
            icon: 'instagram',
            url: 'https://www.instagram.com/netwealth_uk/'
        }
    ];
    @Input() regularity: string =
        `Netwealth Investments Limited is authorised and regulated by the Financial Conduct Authority, with firm reference no. 706988. Registered in England and Wales, with company no. 09493628 and with registered offices at The Bloomsbury Building, 10 Bloomsbury Way, London, WC1A 2SL.`;

    public goToSocial(url: string): void {
        window.open(url, '_blank');
    }
}
